import { Box } from "@mui/material";

/**
 * Simple device frame for product screenshots.
 * Prefer WebP when available; PNG fallback for older browsers.
 */
const PhoneFrame = ({
  src,
  alt,
  maxWidth = 240,
  priority = false,
  light = false,
}) => {
  const webpSrc = typeof src === "string" && src.endsWith(".png")
    ? src.replace(/\.png$/, ".webp")
    : null;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth,
        mx: "auto",
        borderRadius: "28px",
        border: light ? "8px solid #fff" : "10px solid #1a1a2e",
        bgcolor: light ? "#fff" : "#1a1a2e",
        boxShadow: light ? "0 8px 32px rgba(0, 0, 0, 0.12)" : "0 24px 48px rgba(26, 26, 46, 0.28)",
        overflow: "hidden",
        lineHeight: 0,
      }}
    >
      <Box
        component="picture"
        sx={{ display: "block", width: "100%" }}
      >
        {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
        <Box
          component="img"
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          width={472}
          height={1024}
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
            borderRadius: "18px",
          }}
        />
      </Box>
    </Box>
  );
};

export default PhoneFrame;
